var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCidrs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M650.9 362.3c-15.6-6.9-38.3-10.3-68.1-10.3h-77v272.8h63.7v-94.2H599c31.1 0 56-8.2 74.6-24.7 18.6-16.5 28-38 28-64.7 0-17.6-4.6-33.4-13.7-47.5-9.1-14-21.5-24.5-37-31.4zm-49.4 108.2h-33.4v-54.3h36.3c23.4 0 35.2 8.8 35.2 26.3-.1 18.7-12.7 28-38.1 28zM370.6 624.9H433V352.1h-62.4v272.8zm554.2-287.3c-22.6-53.3-54.9-101.3-96-142.4-41.2-41.2-89.1-73.5-142.4-96C631.2 75.8 572.5 64 512 64S392.8 75.8 337.6 99.2c-53.3 22.6-101.3 54.9-142.4 96-41.1 41.1-73.5 89.1-96 142.4C75.8 392.8 64 451.5 64 512s11.8 119.2 35.2 174.4c22.6 53.3 54.9 101.3 96 142.4 41.2 41.2 89.1 73.5 142.4 96C392.8 948.2 451.5 960 512 960s119.2-11.8 174.4-35.2c53.3-22.6 101.3-54.9 142.4-96 41.1-41.1 73.5-89.1 96-142.4C948.2 631.2 960 572.5 960 512s-11.8-119.2-35.2-174.4zM793.9 653.7c0 41.1-33.6 74.7-74.7 74.7H304.7c-41.1 0-74.7-33.6-74.7-74.7V317.9c0-41.1 33.6-74.7 74.7-74.7h414.6c41.1 0 74.7 33.6 74.7 74.7v335.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCidrs);
export default __webpack_public_path__ + "static/media/cidrs.fb45cdc69660dfec8d35051fb379791b.svg";
export { ForwardRef as ReactComponent };